// extracted by mini-css-extract-plugin
export default {"textField":"SetTotalBudgetDialog_textField__4HhiM"};